import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { euro } from "@/lib/shop";

const KEY = "mcanime_recently_viewed";
const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const trackView = (id) => localStorage.setItem(KEY, JSON.stringify([id, ...read().filter((x) => x !== id)].slice(0, 8)));

export const RecentlyViewed = ({ currentId }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const ids = read().filter((x) => x !== currentId);
    if (!ids.length) return setItems([]);
    api.get("/products/by-ids", { params: { ids: ids.join(",") } }).then(({ data }) => setItems(data)).catch(() => {});
  }, [currentId]);
  if (!items.length) return null;
  return (
    <section data-testid="recently-viewed" className="mt-12">
      <h2 className="text-base font-extrabold md:text-lg">Visti di recente</h2>
      <div className="-mx-4 mt-3 flex gap-3 overflow-x-auto px-4 pb-2">
        {items.map((p) => (
          <Link key={p.id} to={`/prodotto/${p.id}`} data-testid={`recent-item-${p.id}`} className="card-mc w-36 shrink-0 overflow-hidden transition-transform duration-150 hover:-translate-y-0.5">
            <div className="aspect-square bg-white">{p.images?.[0] && <img src={imgUrl(p.images[0])} alt={p.name} loading="lazy" className="h-full w-full object-contain p-1" />}</div>
            <div className="border-t border-border p-2">
              <div className="line-clamp-2 text-xs font-bold">{p.name}</div>
              <div className="mt-0.5 text-sm font-extrabold">{p.quantity <= 0 ? "Esaurito" : p.price != null ? euro(p.price) : ""}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
